import axios from "axios";
import { BASE_URL } from "../State/Interceptor/Url";

var ServerURL = process.env.NODE_ENV === 'development' 
? "http://localhost:2000" 
: "https://globe13.in"

const getData = async (url) => {
  try {
    var response = await fetch(`${BASE_URL}${url}`);
    var result = await response.json();
    return result;
  } catch (e) {
    console.log("Error", e);
    return null;
  }
};

const postData = async (url, body) => {
  try {
    const response = await fetch(`${BASE_URL}${url}`, {
      method: "POST",
      mode: "cors",
      headers: { "Content-Type": "application/json;charset=utf-8" },
      body: JSON.stringify(body),
    });
    const result = await response.json();
    return result;
  } catch (e) {
    console.log("Error", e);
    return null;
  }
};

// const postDataAndImage = async (url, formData) => {
//     console.log(formData)
//     try {
//         const response = await axios({
//             method: 'POST',
//             data: formData,
//             url: `${ServerURL}/${url}`,
//             headers: { "content-type": "multiple/FormData" }
//         })
//         var result = await response.data.result;
//         return result;
//     }

//     catch (e) {
//         console.log("Error", e)
//         return null;
//     }
// }

const postDataAndImage = async (url, formData) => {
  try {
    const response = await axios.post(`${BASE_URL}${url}`, formData, {
      headers: { "content-type": "multiple/FormData" },
    });
    const result = await response.data.result;
    return result;
  } catch (e) {
    console.log("Error", e);
    return null;
  }
};

export { ServerURL, postDataAndImage, getData, postData };
